export default __webpack_public_path__ + "5d7ebc4125c11595c9387baf980a0387.svg";